import { NavLink } from 'react-router-dom'
import { breakpoint, styled } from '../styled-components'

export const InnerContainer = styled.div<{ padded?: boolean }>`
  width: 100%;
  max-width: 1160px;
  margin: 0 auto;
  ${props => props.padded && 'padding: 40px 0'};
`

export const Headlines = styled.div`
  margin-bottom: 30px;
  padding: 0 20px;
  text-align: center;
  ${breakpoint('tablet')`
    padding: 0;
    text-align: left;
  `}
`

export const Text = styled.div<{ larger?: boolean }>`
  font-family: ${props => props.theme.textFont};
  font-weight: ${props => props.theme.textWeight};
  font-size: ${props => props.larger ? '18px' : '14px'};
  line-height: ${props => props.larger ? '22px' : '18px'};
`

export const StyledLink = styled(NavLink)`
  color: ${props => props.theme.primaryColor};
`

export const SimpleLink = styled.a`
  color: ${props => props.theme.primaryColor};
`

export const PrimaryText = styled.span<{ bold?: boolean }>`
  color: ${props => props.theme.primaryColor};
  ${props => props.bold && `font-weight: bold;`};
`

export const StrongText = styled.span`
  font-weight: bold;
`

export const Select = styled.select`
  max-width: 100%;
  font-size: 13px;
  font-family: ${props => props.theme.textFont};
  background: ${props => props.theme.inputBackgroundColor};
  border: 1px solid ${props => props.theme.borderColor};
  font-weight: bold;
  border-radius: 3px;
  height: 35px;
  color: ${props => props.theme.headlineColor}; 
`

export const Option = styled.option`
  font-size: 13px;
  font-family: ${props => props.theme.textFont};
  background: ${props => props.theme.inputBackgroundColor};
  border: 1px solid ${props => props.theme.borderColor};
  font-weight: bold;
  color: ${props => props.theme.headlineColor};
`

export const Reg = styled.sup`
  vertical-align: super;
  font-size: smaller;
`

export const CenteredContent = styled.div`
  text-align: center;
`

export const CheckboxLabel = styled.div`
  font-size: 11px;
`